import { Box, Flex, Progress, Text } from "@chakra-ui/react";
import { Col, Row, Empty } from "antd";
import { useState } from "react";

import AddRemoveLineButton from "ui/components/Button/AddRemoveLineButton";
import ModalCentroDeCusto from "ui/components/Features/CentroDeCusto/ModalCentroDeCusto";
import useGetCentrosDeCusto from "core/features/centro-de-custo/hooks/useGetCentrosDeCusto";
import CardDefault from "ui/components/Cards/CardDefault";
import { useLoading } from "ui/components/GlobalLoading";
import CentroDeCustoItem from "./CentroDeCustoItem";
import { CentroDeCustoResponse } from "core/features/centro-de-custo/typings";
import { useInvalidateQuery } from "infra/packages/react-query";

export default function CentrosDeCusto({ tenant }: { tenant?: string }) {
  const [centroDeCustoEdit, setCentroDeCustoEdit] = useState<
    CentroDeCustoResponse | undefined
  >();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();

  const {
    data: centrosDeCusto,
    isLoading,
    isFetching,
    refetch,
  } = useGetCentrosDeCusto({ tenantId: tenant });

  useLoading(isLoading);

  return (
    <CardDefault>
      <Flex mb={8}>
        <Text fontSize="18px" fontWeight="bold">
          Centros de Custo
        </Text>
        <AddRemoveLineButton
          showRemove={false}
          onRemove={() => null}
          onAdd={() => setIsOpenModal(true)}
          containerProps={{ pt: 0, ml: 2, mt: -1 }}
        />
      </Flex>

      {isFetching ? (
        <Progress
          size="sm"
          isIndeterminate
          w="100%"
          my={4}
          colorScheme="cyan"
        />
      ) : null}

      {!isLoading && !isFetching && !centrosDeCusto?.items.length ? (
        <Box>
          <Empty description="Nenhum centro de custo cadastrado" />
        </Box>
      ) : null}

      {!isLoading && centrosDeCusto?.items.length ? (
        <Box>
          <Row gutter={16}>
            {centrosDeCusto?.items.map((centroDeCusto, i) => (
              <Box as={Col} mb={4} lg={8} md={12} key={i}>
                <CentroDeCustoItem
                  onRefresh={() => {
                    refetch();
                  }}
                  onEdit={() => {
                    setCentroDeCustoEdit(centroDeCusto);
                    setIsOpenModal(true);
                  }}
                  tenant={tenant!}
                  centroDeCusto={centroDeCusto}
                />
              </Box>
            ))}
          </Row>
        </Box>
      ) : null}

      {isOpenModal ? (
        <ModalCentroDeCusto
          defaultValue={centroDeCustoEdit}
          isOpenModal={isOpenModal}
          onClose={() => {
            setCentroDeCustoEdit(undefined);
            setIsOpenModal(false);
          }}
          tenantId={tenant}
          onSuccess={() => {
            refetch();
            setCentroDeCustoEdit(undefined);
            setIsOpenModal(false);
            doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
          }}
        />
      ) : null}
    </CardDefault>
  );
}
